import gql from 'graphql-tag';

export default gql`
  query GetAllPosts(
    $type: PostType
    $searchTerm: String
    $categoryFilter: [PostCategory!]
    $statusFilter: PostStatus
  ) {
    posts(
      orderBy: updatedAt_DESC
      where: {
        type: $type
        category_in: $categoryFilter
        status: $statusFilter
        OR: [{ body_contains: $searchTerm }, { title_contains: $searchTerm }]
      }
    ) {
      createdAt
      id
      updatedAt
      title
      body
      status
      type
      category
      roles
      image {
        createdAt
        id
        updatedAt
        thumbnail
        scaled
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/GetAllPosts.ts